import { IdentityVerificationModal } from './identityVerificationModal';
import IdentityVerificationPage from './identityVerificationPage';

export { IdentityVerificationModal };
export default IdentityVerificationPage;
